import React, { useEffect, useState } from 'react'

import { makeStyles } from '@material-ui/core'
import TextField from '@material-ui/core/TextField'
import Autocomplete from '@material-ui/lab/Autocomplete'

import WeatherWidget from '.'
import { getMetricSystemByCityId } from './util'

const useStyles = label =>
  makeStyles({
    root: {
      padding: '30px',
    },
    list: {
      display: 'flex',
      flexDirection: 'row',
      flexWrap: 'wrap',
    },
    card: {
      width: '46%',
      margin: '12px',
    },
    select: {
      margin: '12px',
    },
    hidden: {
      visibility: 'hidden',
      width: '0px !important',
      height: '0px !important',
      margin: '0px !important',
      padding: '0px !important',
    },
  })()

const WeatherList = ({ cities }) => {
  const [search, setSearch] = useState('')
  const classes = useStyles()

  const [renderedItems, setRenderedItems] = useState([])

  useEffect(() => {
    cities.forEach((c, i) => {
      // Lazy loading components to avoid vendor rate-limit.
      setTimeout(() => {
        setRenderedItems(prev => [...prev, c])
      }, i * 250)
    })
  }, [])

  return (
    <div className={classes.root}>
      <div className={classes.select}>
        <Autocomplete
          id="combo-box-demo"
          value={search}
          onInputChange={(event, newValue) => {
            setSearch(newValue)
          }}
          onChange={(event, newValue) => {
            setSearch(newValue)
          }}
          options={cities.map(({ name }) => name)}
          style={{ width: 300 }}
          renderInput={params => (
            <TextField {...params} label="City" variant="outlined" />
          )}
        />
      </div>
      <div className={classes.list}>
        {renderedItems.map(city => {
          const hidden =
            search &&
            search.length &&
            !city.name.toLowerCase().includes(search.toLowerCase())

          return (
            <WeatherWidget
              key={city.name}
              label={city.name}
              metric={getMetricSystemByCityId(city.id)}
              lat={city.location.latitude}
              lng={city.location.longitude}
              className={hidden ? classes.hidden : classes.card}
              listItem
            />
          )
        })}
      </div>
    </div>
  )
}

export default WeatherList
